import { useSWRConfig } from "swr";
import React, { useState } from "react";
import FormModal from "../common/FormModal";
import { Form } from "react-bulma-components";
import { fetcher } from "../utils/fetch";

export default function AddNewContactForm({ onClose, project, show }) {
    const { mutate } = useSWRConfig();

    const [association, setAssociation] = useState();
    const [contactName, setContactName] = useState();
    const [contactPhone, setContactPhone] = useState();
    const [contactEmail, setContactEmail] = useState();
    const [contactWebsite, setContactWebsite] = useState();

    const onSubmit = async () => {
        try {
            // First, add the new contact
            const contact = await fetcher(`/api/contacts`, {
                method: 'POST',
                body: JSON.stringify({
                    name: contactName,
                    email_address: contactEmail,
                    phone_number: contactPhone,
                    website: contactWebsite
                })
            });

            await mutate('/api/contacts');

            // Then add them to the project
            await fetcher(`/api/projects/${ project.id }/contacts`, {
                method: 'POST',
                body: JSON.stringify({
                    association: association,
                    contact: {
                        id: contact.id
                    }
                })
            });

            await mutate(`/api/projects/${ project.id }`);
        } catch (e) {
            // TODO: Check for validation errors
            // TODO: Check for catastrophic failures
            console.error('oops', e);
        }

        onClose();


        const errorResponse = {
            "field": [
                'one validation message',
                'two validation message'
            ]
        };
    };

    return (
        <FormModal title="Add new contact" onSubmit={ onSubmit } onClose={ onClose } show={ show }>
            <Form.Field horizontal>
                <Form.Field.Label>
                    <Form.Label>Name</Form.Label>
                </Form.Field.Label>
                <Form.Field.Body>
                    <Form.Field>
                        <Form.Control>
                            <Form.Input onChange={ e => setContactName(e.currentTarget.value) }/>
                        </Form.Control>
                    </Form.Field>
                </Form.Field.Body>
            </Form.Field>

            <Form.Field horizontal>
                <Form.Field.Label>
                    <Form.Label>Phone Number</Form.Label>
                </Form.Field.Label>
                <Form.Field.Body>
                    <Form.Field>
                        <Form.Control>
                            <Form.Input onChange={ e => setContactPhone(e.currentTarget.value) }/>
                        </Form.Control>
                    </Form.Field>
                </Form.Field.Body>
            </Form.Field>

            <Form.Field horizontal>
                <Form.Field.Label>
                    <Form.Label>Email address</Form.Label>
                </Form.Field.Label>
                <Form.Field.Body>
                    <Form.Field>
                        <Form.Control>
                            <Form.Input type="email" onChange={ e => setContactEmail(e.currentTarget.value) }/>
                        </Form.Control>
                    </Form.Field>
                </Form.Field.Body>
            </Form.Field>

            <Form.Field horizontal>
                <Form.Field.Label>
                    <Form.Label>Website</Form.Label>
                </Form.Field.Label>
                <Form.Field.Body>
                    <Form.Field>
                        <Form.Control>
                            <Form.Input type="url" onChange={ e => setContactWebsite(e.currentTarget.value) }/>
                        </Form.Control>
                    </Form.Field>
                </Form.Field.Body>
            </Form.Field>

            <Form.Field horizontal>
                <Form.Field.Label>
                    <Form.Label>Association</Form.Label>
                </Form.Field.Label>
                <Form.Field.Body>
                    <Form.Field>
                        <Form.Control>
                            <Form.Input onChange={ e => setAssociation(e.currentTarget.value) }/>
                        </Form.Control>
                    </Form.Field>
                </Form.Field.Body>
            </Form.Field>
        </FormModal>
    )
}
